<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12" v-bind:class="{'col-md-9': uiSidebarVisible }">
                <div v-if="isMobile" id="js-menu-mobile" class="account__menu-mobile">
                    <div class="row no-gutters">
                        <div class="col-4 account__menu-mobile-item account__menu-mobile-item--border-right  " :class="[uiTabActive.key === 'account' ? 'text--white bg-green' : 'text--green' ]" @click="handleUiTabClick('account')">{{ $t("myAccount.titlePersonalInformation") }}</div>
                        <div class="col-4 account__menu-mobile-item account__menu-mobile-item--border-right text--green" :class="[uiTabActive.key === 'order-history' ? 'text--white bg-green' : 'text--green' ]" @click="handleUiTabClick('order-history')"><div>{{ $t("myAccount.titleOrderHistory") }}</div></div>
                        <div class="col-4 account__menu-mobile-item account__menu-mobile-item--border-right text--green">
                            <a class="text--green" :href="logoutLink" title="logout">{{ $t("myAccount.logout") }}</a>
                        </div>
                    </div>
                </div>
                <div class="pb-2 px-2 row no-gutters" v-if="!isMobile || uiTabActive.key === 'order-history' " v-bind:class="[!isMobile ? '' : 'account__border--thick account__card']">
                    <div class="offset-3 col-6">
                        <h1 class="account__top--title pt-2" v-text="uiTabActive.title"></h1>
                        <div v-if="isMobile" class="text-center account__top--description" v-text="uiTabActive.mobileDescription" ></div>
                        <div v-if="!isMobile" class="text-center account__top--description" v-text="uiTabActive.description"></div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center" v-if="!isApp">
                        <button class="button-brekz button-brekz--light-green button-brekz--sm button-brekz--rounded" data-toggle="modal" data-target="#appModal">
                            <i class="fas fa-mobile-alt mr-1 text--gray-600"></i>App
                        </button>
                    </div>
                </div>
                <div v-if="!isMobile" class="account__menu">
                    <div class="row no-gutters">
                        <div class="col position-relative" @click="handleUiTabClick('account')">
                            <div class="account__menu-item account__menu-item--border-right">
                                <i class="text--xl text--gray-mid fas fa-address-book mr-2"></i>
                                <div>{{ $t("myAccount.titlePersonalInformation") }}</div>
                            </div>
                            <div v-show="uiTabActive.key === 'account'" class="account__menu--arrow-up"></div>
                        </div>
                        <div class="col position-relative" @click="handleUiTabClick('order-history')">
                            <div class="account__menu-item account__menu-item--border-right align-items-center">
                                <i class="fas fa-box-open text--xl text--gray-mid mr-2"></i>
                                <div>{{ $t("myAccount.titleOrderHistory") }}</div>
                            </div>
                            <div v-show="uiTabActive.key === 'order-history'" class="account__menu--arrow-up"></div>

                        </div>
                        <div class="col">
                            <div class="account__menu-item">
                                <div class="d-flex align-items-center mr-2 position-relative">
                                    <i class="text--lg text--gray-mid fal fa-sign-out mr-2"></i>
                                    <a title="logout" :href="logoutLink">{{ $t("myAccount.logout") }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <keep-alive>
                    <account
                        v-if="uiTabActive.key === 'account'"
                        v-bind:isMobile="isMobile"
                        :get-address-link="getAddressLink"
                        :get-account-link="getAccountLink"
                        :update-account-link="updateAccountLink"
                        :default-country-id="defaultCountryId">
                    </account>
                </keep-alive>
                <order-history :get-orders-link="getOrdersLink" :reorder-link="reorderLink" v-show="uiTabActive.key === 'order-history'" v-bind:isMobile="isMobile"></order-history>
            </div>
            <div class="d-none d-md-block" v-bind:class="{'col-3': uiSidebarVisible }" style="border-left: 2px solid #C8E1C8;">
                <cart :get-cart-link="getCartLink" :account-cart-link="AccountCartLink" v-show="uiTabActive.key === 'order-history'" :checkout-link="checkoutLink"></cart>
            </div>
        </div>

        <slot name="app-modal"></slot>
    </div>
</template>

<script>
    import Account from "./Account";
    import OrderHistory from "./OrderHistory";
    import Cart from "./Cart";
    import ModalVue from "./ModalVue";
    import { isBrekzApp } from "../js/helper/app-helper";

    export default {
        name: "AccountManagement",
        components: {
            Cart,
            Account,
            OrderHistory,
            ModalVue
        },
        props: {
            logoutLink: String,
            checkoutLink: String,
            appLink: String,
            defaultCountryId: Number,
            getOrdersLink: String,
            getCartLink: String,
            getAddressLink: String,
            getAccountLink: String,
            AccountCartLink: String,
            updateAccountLink: String,
            reorderLink: String,
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                isApp: isBrekzApp(),
                uiTabActive: {
                    key: null
                },
                uiTabs: [
                    {
                        key: 'account',
                        title: this.$t("myAccount.titlePersonalInformation"),
                        description: this.$t("myAccount.addressDescription"),
                        mobileDescription: this.$t("myAccount.addressDescription")
                    },
                    {
                        key: 'order-history',
                        title: this.$t("myAccount.titleMyOrders"),
                        description: this.$t("myAccount.orderDescription"),
                        mobileDescription: this.$t("myAccount.orderDescriptionShort"),
                    }
                ],
                appModalVisible: false
            }
        },
        mounted() {
                window.addEventListener('resize', () => {
                    this.windowWidth = window.innerWidth;
                });
                window.addEventListener("hashchange", () => {
                    this.handleUiTabClick(this.getTabKeyFromUrl());
                });

                this.handleUiTabClick(this.getTabKeyFromUrl() ? this.getTabKeyFromUrl() : 'order-history');
        },
        methods: {
            handleUiTabClick(uiTabKey) {
                this.changeTab(
                    this.uiTabs.find((uiTab) => {
                        window.EventBus.$emit('uiTabActiveChild', uiTab.key);
                        return uiTab.key === uiTabKey;
                    })
                );

            },
            toggleModal() {
                document.body.classList.add("modal-vue--open");
                this.appModalVisible = true
            },
            getTabKeyFromUrl(){
                return new URL(window.location.href).hash.substring(1);
            },
            changeTab(tab){
                location.hash = tab.key;
                this.uiTabActive = tab;
                if(window.handleBottomNav){
                    window.handleBottomNav(tab.key);
                }

            }
        },
        computed: {
            isMobile() {
                return this.windowWidth <= 767
            },
            uiSidebarVisible() {

                return true;
            }
        },
    }
</script>
